import type { MouseEvent, ReactElement } from "react";
import { Icon } from "../ui/Icon/Icon";
import type { NavItemData } from "../lib/navigation";
import styles from "./NavItem.module.css";

export interface NavItemProps {
  item: NavItemData;
  active: boolean;
  onNavigate?: (href: string) => void;
  index?: number;
  bare?: boolean;
}

export function NavItem({
  item,
  active,
  onNavigate,
  index,
  bare = false,
}: NavItemProps): ReactElement {
  const disabled = item.badge === "Soon";
  const className = [
    styles.item,
    bare ? styles.bare : "",
    active ? styles.active : "",
    disabled ? styles.disabled : "",
  ]
    .filter(Boolean)
    .join(" ");
  const navIndex = index === undefined ? undefined : String(index);

  const inner = (
    <>
      <span className={styles.icon}>
        <Icon name={item.icon} size={18} />
      </span>
      <span className={styles.label}>{item.label}</span>
      {item.badge ? <span className={styles.badge}>{item.badge}</span> : null}
    </>
  );

  if (disabled) {
    return (
      <span className={className} aria-disabled="true" data-nav-index={navIndex}>
        {inner}
      </span>
    );
  }

  return (
    <a
      className={className}
      href={item.href}
      data-nav-index={navIndex}
      aria-current={active ? "page" : undefined}
      onClick={(event: MouseEvent) => {
        if (onNavigate) {
          event.preventDefault();
          onNavigate(item.href);
        }
      }}
    >
      {inner}
    </a>
  );
}
